/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Read_Along_Ai_DurationInputs */

const en_read_along_ai_duration = /** @type {(inputs: Read_Along_Ai_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Model request: ${i?.seconds} s`)
};

const es_read_along_ai_duration = /** @type {(inputs: Read_Along_Ai_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Solicitud al modelo: ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "Model request: {seconds} s" |
*
* @param {Read_Along_Ai_DurationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_duration = /** @type {((inputs: Read_Along_Ai_DurationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_DurationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_duration(inputs)
	return en_read_along_ai_duration(inputs)
});